const TrainDark = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path
      d="M9 1H3C2.15 1 1.5 1.65 1.5 2.5V8.5C1.5 9.15 1.9 9.7 2.5 9.9V10.5C2.5 10.8 2.7 11 3 11C3.3 11 3.5 10.8 3.5 10.5V10H8.5V10.5C8.5 10.8 8.7 11 9 11C9.3 11 9.5 10.8 9.5 10.5V9.9C10.1 9.7 10.5 9.15 10.5 8.5V2.5C10.5 1.65 9.85 1 9 1ZM4 8.5C3.7 8.5 3.5 8.3 3.5 8C3.5 7.7 3.7 7.5 4 7.5C4.3 7.5 4.5 7.7 4.5 8C4.5 8.3 4.3 8.5 4 8.5ZM5.5 6.5H3C2.7 6.5 2.5 6.3 2.5 6V4C2.5 3.7 2.7 3.5 3 3.5H5.5V6.5ZM8 8.5C7.7 8.5 7.5 8.3 7.5 8C7.5 7.7 7.7 7.5 8 7.5C8.3 7.5 8.5 7.7 8.5 8C8.5 8.3 8.3 8.5 8 8.5ZM9.5 6C9.5 6.3 9.3 6.5 9 6.5H6.5V3.5H9C9.3 3.5 9.5 3.7 9.5 4V6Z"
      fill="#374151"
    />
  </svg>
);

export default TrainDark;
